// @ts-nocheck
/* Starter Sync - QuickOrderActions */

import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import calculateTotal from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/CalculateTotal";
import changeProductQty from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/ChangeProductQty";
import removeProduct from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/RemoveProduct";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer, { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import CardList from "@insite/content-library/Components/CardList";
import LocalizedCurrency from "@insite/content-library/Components/LocalizedCurrency";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
// import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered"; // Starter Custom Code
import Clickable, { ClickableProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconPresentationProps } from "@insite/mobius/Icon";
import XCircle from "@insite/mobius/Icons/XCircle";
import { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
// import React, { useEffect } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import siteMessage from "@insite/client-framework/SiteMessage";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { TextFieldPresentationProps } from "@insite/mobius/TextField/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import ArrowUpward from "@store/Library/Components/Toolkit/Icons/ArrowUpward";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import OrderActionSet from "@store/Library/Components/Toolkit/Order/OrderActionSet";
import Link, { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { useShowProductAvailability } from "@store/Overrides/Components/ProductAvailability";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import ProductQuantityOrdered from "@store/Overrides/Components/ProductQuantityOrdered";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useIsPunchOutSession } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC, useContext, useEffect, useState } from "react";
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    productInfos: state.pages.quickOrder.productInfos,
    products: state.pages.quickOrder.productInfos.map(o => getProductState(state, o.productId).value) as (
        | ProductModel
        | undefined
    )[],
    total: state.pages.quickOrder.total,
    currencySymbol: state.context.session.currency?.currencySymbol || "",
    showPricing: state.context.showPricing,
    // Starter Custom Code
    allowMultipleWishLists: getSettingsCollection(state).wishListSettings.allowMultipleWishLists,
});

const mapDispatchToProps = {
    calculateTotal,
    changeProductQty,
    removeProduct,
    // Starter Custom Code
    setAddToListModalIsOpen,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface QuickOrderProductListStyles {
    wrapper?: InjectableCss;
    cardContainer?: CardContainerStyles;
    gridContainer?: GridContainerProps;
    productImageGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    productInfoGridItem?: GridItemProps;
    productInfoContainer?: GridContainerProps;
    brandAndProductDescriptionGridItem?: GridItemProps;
    brand?: ProductBrandStyles;
    productDescription?: ProductDescriptionStyles;
    productNumberText?: ProductPartNumbersStyles; // Starter Custom Code
    availability?: ProductAvailabilityStyles;
    priceAndQuantityGridItem?: GridItemProps;
    priceAndQuantityContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    price?: ProductPriceStyles;
    quantityGridItem?: GridItemProps;
    quantityOrdered?: TextFieldPresentationProps; // Starter Custom Code
    extendedPriceGridItem?: GridItemProps;
    extendedPriceText?: TypographyPresentationProps;
    removeProductGridItem?: GridItemProps;
    removeProductClickable?: ClickableProps;
    removeProductIcon?: IconPresentationProps;
    addToListLink?: ProductAddToListLinkStyles;
    totalText?: TypographyPresentationProps;
    // Starter Custom Code
    centeringWrapper?: InjectableCss;
    noResultsText?: TypographyPresentationProps;
    removeLink?: LinkPresentationProps;
    productPartNumbersGridItem?: GridItemProps;
    productPartNumbers?: ProductPartNumbersStyles;
    quantityAndExtendedUnitNetPriceGridItem?: GridItemProps;
    quantityAndExtendedUnitNetPriceContainer?: GridContainerProps;
    productPriceAndAvailabilityGridItem?: GridItemProps;
    extendedUnitNetPriceGridItem?: GridItemProps;
    availabilityGridItem?: GridItemProps;
    cartLineInfoGridItem?: GridItemProps;
    cartLineInfoContainer?: GridContainerProps;
    extendedUnitNetPriceLabel?: TypographyPresentationProps;
    headerWrapper?: InjectableCss;
    itemCountText?: TypographyPresentationProps;
    footerWrapper?: InjectableCss;
    backToTopLink?: LinkPresentationProps;
    addAllToListLink?: LinkPresentationProps;
    removeAllLink?: LinkPresentationProps;
}

export const quickOrderProductListStyles: QuickOrderProductListStyles = {
    wrapper: {
        css: css`
            ${breakpointValues(pxToRemArray([25, null, 30, 40]), "margin-top")}

            &:first-child {
                margin-top: 0;
            }
        `,
    },
    noResultsText: typographyGetNoResultsAltProps({ spaced: true }),
    gridContainer: productLineProps.container,
    productImageGridItem: productLineProps.imageGridItem,
    productImage: productLineProps.image,
    removeLink: productLineProps.removeLink,
    addToListLink: {
        link: productLineProps.addToListLink,
    },
    cartLineInfoGridItem: productLineProps.contentGridItem,
    cartLineInfoContainer: productLineProps.contentContainer,
    productInfoGridItem: productLineProps.infoGridItem,
    productInfoContainer: productLineProps.infoContainer,
    brandAndProductDescriptionGridItem: productLineProps.descriptionGridItem,
    brand: productLineProps.brand,
    productDescription: mergeProps<QuickOrderProductListStyles["productDescription"]>(productLineProps.description, {
        productDetailDescription: {
            forwardAs: "h2",
        },
        productDetailLink: {
            typographyProps: {
                forwardAs: "h2",
            },
        },
    }),
    productPartNumbersGridItem: productLineProps.partNumbersGridItem,
    productPartNumbers: productLineProps.partNumbers,
    availabilityGridItem: productLineProps.availabilityGridItem,
    availability: productLineProps.availability,
    quantityAndExtendedUnitNetPriceGridItem: productLineProps.pricingGridItem,
    quantityAndExtendedUnitNetPriceContainer: productLineProps.pricingContainer,
    productPriceAndAvailabilityGridItem: productLineProps.priceGridItem,
    price: productLineProps.price,
    quantityGridItem: productLineProps.quantityGridItem,
    quantityOrdered: productLineProps?.quantity?.editableQuantityTextField,
    extendedPriceGridItem: productLineProps.subtotalGridItem,
    extendedUnitNetPriceLabel: productLineProps.subtotalLabel,
    extendedPriceText: productLineProps.subtotalValue,
    extendedUnitNetPriceGridItem: productLineProps.subtotalGridItem,
    totalText: productLineProps.subtotalSecondValue,
    headerWrapper: resultCountProps.wrapper,
    itemCountText: resultCountProps.countText,
    footerWrapper: resultCountProps.bottomWrapper,
    addAllToListLink: { icon: { iconProps: { src: PlusCircleFill } } },
    removeAllLink: { icon: { iconProps: { src: TrashFill } } },
    backToTopLink: linkGetActionLinkProps(ArrowUpward),
};

const styles = quickOrderProductListStyles;
const StyledSection = getStyledWrapper("section");

const QuickOrderProductList = ({
    products,
    productInfos,
    total,
    currencySymbol,
    showPricing,
    calculateTotal,
    changeProductQty,
    removeProduct,
    // Starter Custom Code
    allowMultipleWishLists,
    setAddToListModalIsOpen,
}: Props) => {
    /* Starter Custom Code - Start */
    const toasterContext = useContext(ToasterContext);
    const [allQtysIsValid, setAllQtysIsValid] = useState(false);
    const isPunchOutSession = useIsPunchOutSession();
    const showAvailability = useShowProductAvailability();
    const trackProductRemovedFromQuickOrder = ga.use.trackProductRemovedFromQuickOrder();
    const trackQuantityChangedInQuickOrder = ga.use.trackQuantityChangedInQuickOrder();

    useEffect(() => {
        setAllQtysIsValid(productInfos.every(o => o.qtyOrdered > 0));
    }, [productInfos]);

    const productQuantityOrderedHandler = () => {
        trackQuantityChangedInQuickOrder();
    };
    /* Starter Custom Code - End */

    useEffect(() => calculateTotal(), [products]);

    const removeProductHandler = (productInfo: ProductInfo) => {
        trackProductRemovedFromQuickOrder(); // Starter Custom Code
        removeProduct({ productId: productInfo.productId, unitOfMeasure: productInfo.unitOfMeasure });
    };

    if (!products || products.length === 0) {
        /* Starter Custom Code - Start */
        return <Typography {...styles.noResultsText}>{siteMessage("QuickOrder_ProductListEmpty")}</Typography>;
        /* Starter Custom Code - End */
    }

    const productListDisplay = products.map((product, index) => {
        if (!product || index >= productInfos.length) {
            return;
        }

        const productInfo = productInfos[index];
        const productContext: ProductContextModel = {
            product,
            productInfo,
            onQtyOrderedChanged: debounce(qtyOrdered => {
                changeProductQty({
                    qtyOrdered,
                    productId: product.id,
                    unitOfMeasure: productInfo.unitOfMeasure,
                    product,
                });
            }, 300),
        };

        return (
            <ProductContext.Provider value={productContext} key={product.id + productInfo.unitOfMeasure}>
                {/* Starter Custom Code - Start */}
                <GridContainer
                    {...styles.gridContainer}
                    data-test-selector={`QuickOrderProductList_ProductId_${product.id}`}
                >
                    <GridItem {...styles.productImageGridItem}>
                        <ProductImage product={productContext} extendedStyles={styles.productImage} />
                        <ProductAddToListLink extendedStyles={styles.addToListLink} />
                        <Link
                            {...styles.removeLink}
                            onClick={() => removeProductHandler(productInfo)}
                            data-test-selector="quickOrder_RemoveProduct"
                        >
                            {translate("Remove")}
                        </Link>
                    </GridItem>
                    <GridItem {...styles.cartLineInfoGridItem}>
                        <GridContainer {...styles.cartLineInfoContainer}>
                            <GridItem {...styles.productInfoGridItem}>
                                <GridContainer {...styles.productInfoContainer}>
                                    <GridItem {...styles.brandAndProductDescriptionGridItem}>
                                        {product.brand && (
                                            <ProductBrand brand={product.brand!} extendedStyles={styles.brand} />
                                        )}
                                        <ProductDescription
                                            product={productContext}
                                            extendedStyles={styles.productDescription}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.productPartNumbersGridItem}>
                                        <ProductPartNumbers
                                            productNumber={product.productNumber}
                                            customerProductNumber={product.customerProductNumber}
                                            manufacturerItem={product.manufacturerItem}
                                            extendedStyles={styles.productPartNumbers}
                                        />
                                    </GridItem>
                                    {showAvailability && !product.quoteRequired && (
                                        <GridItem {...styles.availabilityGridItem}>
                                            <ProductContextAvailability extendedStyles={styles.availability} />
                                        </GridItem>
                                    )}
                                </GridContainer>
                            </GridItem>
                            <GridItem {...styles.quantityAndExtendedUnitNetPriceGridItem}>
                                <GridContainer {...styles.quantityAndExtendedUnitNetPriceContainer}>
                                    {showPricing && (
                                        <GridItem {...styles.productPriceAndAvailabilityGridItem}>
                                            <ProductPrice
                                                product={productContext}
                                                currencySymbol={currencySymbol}
                                                showSavings={false}
                                                showLabel={true}
                                                extendedStyles={styles.price}
                                            />
                                        </GridItem>
                                    )}
                                    <GridItem {...styles.quantityGridItem}>
                                        <ProductQuantityOrdered
                                            extendedStyles={styles.quantityOrdered}
                                            onBlur={productQuantityOrderedHandler} // Starter Custom Code
                                        />
                                    </GridItem>
                                    {!product.quoteRequired &&
                                        !productInfo.pricing?.requiresRealTimePrice &&
                                        showPricing && (
                                            <GridItem {...styles.extendedUnitNetPriceGridItem}>
                                                <Typography {...styles.extendedUnitNetPriceLabel}>
                                                    {translate("Subtotal")}
                                                </Typography>
                                                <Typography
                                                    {...styles.extendedPriceText}
                                                    data-test-selector="quickOrder_ProductPrice"
                                                >
                                                    {productInfo.pricing?.extendedUnitNetPriceDisplay}
                                                </Typography>
                                            </GridItem>
                                        )}
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    {/* Starter Moved - removeProductGridItem */}
                </GridContainer>
                {/* Starter Custom Code - End */}
            </ProductContext.Provider>
        );
    });

    /* Starter Custom Code - Start */
    const removeAllProductsHandler = () => {
        productInfos.forEach((productInfo: ProductInfo) => {
            removeProduct({ productId: productInfo.productId, unitOfMeasure: productInfo.unitOfMeasure });
        });
    };

    const addToListClickHandler = () => {
        const productInfosToAdd = productInfos.filter(o => products.find(p => p?.id === o.productId)?.canAddToWishlist);
        if (!allowMultipleWishLists) {
            addToWishList({
                productInfos: productInfosToAdd,
                onSuccess: () => {
                    toasterContext.addToast({ body: siteMessage("Lists_ProductAdded"), messageType: "success" });
                },
            });
            return;
        }

        setAddToListModalIsOpen({ modalIsOpen: true, productInfos: productInfosToAdd });
    };

    const canAddSomeToList = products.some(o => o?.canAddToWishlist) && !isPunchOutSession;
    const itemCount = products.length;
    const itemsText = itemCount === 1 ? translate("Item") : translate("Items");
    /* Starter Custom Code - End */

    return (
        <>
            <StyledSection {...styles.wrapper} id="quickHeader">
                {/* Starter Custom Code - Start */}
                {products && (
                    <StyledSection {...styles.headerWrapper}>
                        <Typography {...styles.itemCountText}>{`${itemCount} ${itemsText}`}</Typography>
                        <OrderActionSet
                            displayType="linkOverflow"
                            overflowBreakpoint="xs"
                            actions={[
                                {
                                    key: "list",
                                    label: translate("Add All to List"),
                                    onClick: addToListClickHandler,
                                    isDisabled: !allQtysIsValid,
                                    linkStyles: styles.addAllToListLink,
                                    testSelector: "quickOrder_addAllProductsToList",
                                    isVisible: canAddSomeToList,
                                },
                                {
                                    key: "removeAll",
                                    label: translate("Remove All"),
                                    onClick: removeAllProductsHandler,
                                    linkStyles: styles.removeAllLink,
                                },
                            ]}
                        />
                    </StyledSection>
                )}
                {productListDisplay}
                <ProductListFooter />
                {/* Starter Custom Code - End */}
            </StyledSection>
            {/* Starter Moved - Total - QuickOrderSummary widget */}
        </>
    );
};

/* Starter Custom Code - Start */
const ProductListFooter: FC = () => {
    const backToTopClickHandler = () => {
        const header = document.getElementById("quickHeader");
        if (header) {
            window.scrollTo(0, header.offsetTop);
        }
    };

    return (
        <StyledSection {...styles.footerWrapper}>
            <Link onClick={backToTopClickHandler} {...styles.backToTopLink}>
                {translate("Back to Top")}
            </Link>
        </StyledSection>
    );
};
/* Starter Custom Code - End */

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(QuickOrderProductList),
    definition: {
        group: "Quick Order",
        icon: "List",
        allowedContexts: ["QuickOrderPage"],
    },
};

export default widgetModule;
